import React from 'react';
import Icon from '../../../components/AppIcon';

const TeamStats = () => {
  const stats = [
    {
      icon: 'Users',
      value: '45+',
      label: 'Expert Consultants',
      description: 'Across all specializations'
    },
    {
      icon: 'GraduationCap',
      value: '120+',
      label: 'Advanced Degrees',
      description: 'PhD, Masters, and certifications'
    },
    {
      icon: 'Award',
      value: '200+',
      label: 'Industry Certifications',
      description: 'AWS, Azure, Google Cloud, and more'
    },
    {
      icon: 'Calendar',
      value: '15+',
      label: 'Average Experience',
      description: 'Years in technology consulting'
    },
    {
      icon: 'Globe',
      value: '25+',
      label: 'Countries Served',
      description: 'Global client engagement'
    },
    {
      icon: 'Building2',
      value: '500+',
      label: 'Enterprise Clients',
      description: 'Fortune 500 and growing companies'
    }
  ];

  return (
    <div className="bg-gradient-to-r from-primary/5 to-secondary/5 rounded-xl p-8 border border-primary/10 mb-12">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-foreground mb-4">Our Team by Numbers</h2>
        <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
          Collective expertise and experience that drives innovation and delivers results for our clients worldwide.
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="bg-white rounded-lg p-6 text-center shadow-soft border border-border hover:shadow-elevation transition-smooth"
          >
            <div className="w-12 h-12 rounded-full gradient-primary flex items-center justify-center mx-auto mb-4">
              <Icon name={stat.icon} size={24} color="white" />
            </div>
            <div className="text-3xl font-bold text-foreground mb-2">{stat.value}</div>
            <div className="text-lg font-semibold text-foreground mb-1">{stat.label}</div>
            <div className="text-sm text-muted-foreground">{stat.description}</div>
          </div>
        ))}
      </div>
      
      <div className="mt-8 text-center">
        <div className="inline-flex items-center space-x-2 bg-white rounded-full px-6 py-3 shadow-soft border border-border">
          <Icon name="TrendingUp" size={20} className="text-success" />
          <span className="text-sm font-medium text-foreground">
            Growing team with 95% client satisfaction rate
          </span>
        </div>
      </div>
    </div>
  );
};

export default TeamStats;